function setTickerDuration(dom) {
    const width = dom.offsetWidth
    const time = (width * 30) / 2000
    const duration = '--ticker-duration: ' + time + 's'

    dom.setAttribute('style', duration)
}

export default function tickerDuration() {
    const tickerElement = document.querySelector('.ticker')

    if (tickerElement != null) {
        setTickerDuration(tickerElement)
    }
}
